import { rem } from 'polished';
import styled from 'styled-components';

const sizes = {
  icon: {
    width: 40,
    gutter: 5,
  },
};

export const IconWrapper = styled.span`
  width: 100%;
  margin-bottom: -${rem(sizes.icon.width + sizes.icon.gutter)};
  order: 3;

  .icon {
    width: ${rem(sizes.icon.width)};
    height: ${rem(sizes.icon.width)};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    width: ${rem(26)};
    height: ${rem(26)};
    display: block;
  }
`;
